import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ugc-media-slider_navigation" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]

import {
  ref, computed, onMounted, nextTick, inject, onBeforeUnmount,
} from 'vue';
import { navigateKey } from '@drapejs/core';
import UGCMedia from '@/components/UGCMedia/UGCMedia.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'UGCMediaSlider',
  props: {
  items: {
    type: Array,
    default: () => [] as Array<any>,
  },
  showItems: {
    type: Number,
    default: 4,
  },
  widthToHeightRatio: {
    type: Number,
    default: 100,
  }
},
  setup(__props) {

const props = __props

const navigate = inject(navigateKey);

// eslint-disable-next-line no-undef


const forceComputeScroll = ref(0);
const container = ref({} as any);

const canScrollRight = computed(() => {
  if (forceComputeScroll.value < 0 || props.items.length === 0) {
    return false;
  }

  const currentScrollLeftWithMargin = container.value.scrollLeft + 10;
  const totalScrollTrackOutsideView = container.value.scrollWidth - container.value.clientWidth;

  return container.value
    && currentScrollLeftWithMargin < totalScrollTrackOutsideView;
});

const canScrollLeft = computed(() => {
  if (forceComputeScroll.value < 0 || props.items.length === 0) {
    return false;
  }

  return container.value && container.value.scrollLeft > 0;
});

let refreshInterval: undefined|number;
onMounted(async () => {
  await nextTick();
  refreshInterval = setInterval(refreshScrollableState, 500);
});

onBeforeUnmount(() => {
  clearInterval(refreshInterval);
});

function refreshScrollableState() {
  forceComputeScroll.value = forceComputeScroll.value === 0 ? 1 : 0;
}

function getScrollIncrement() {
  return (container.value.scrollWidth / props.items.length)
    + parseFloat(getComputedStyle(document.documentElement).fontSize);
}

function goPrev() {
  if (!canScrollLeft.value) {
    return;
  }

  container.value.scrollLeft -= getScrollIncrement();
}

function goNext() {
  if (!canScrollRight.value) {
    return;
  }

  container.value.scrollLeft += getScrollIncrement();
}

function handleProductTagClick(tag) {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  navigate!(tag.variant.url);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "ugc-media-slider_list",
      ref_key: "container",
      ref: container,
      onScroll: refreshScrollableState
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(`ugc-media-slider_product ugc-media-slider_product-${props.showItems}`),
          key: (item as any).imageId
        }, [
          _createVNode(UGCMedia, _mergeProps((item as any), {
            onProductClick: handleProductTagClick,
            "width-to-height-ratio": props.widthToHeightRatio
          }), null, 16, ["width-to-height-ratio"])
        ], 2))
      }), 128))
    ], 544),
    _createElementVNode("div", _hoisted_1, [
      (_unref(canScrollLeft))
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _withModifiers(goPrev, ["prevent"]),
            class: "ugc-media-slider_navigation-prev clean-button"
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      (_unref(canScrollRight))
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: _withModifiers(goNext, ["prevent"]),
            class: "ugc-media-slider_navigation-next clean-button"
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})